import { clamp } from "./plate";
import { t } from "../i18n/strings";

export function colorForScore(score) {
  if (score === null || score === undefined) return "var(--score-none)";
  if (score >= 4.5) return "var(--score-excellent)";
  if (score >= 3) return "var(--score-trusted)";
  if (score >= 2) return "var(--score-caution)";
  return "var(--score-poor)";
}

export function verdictForScore(score, lang) {
  if (score === null || score === undefined) return t(lang, "verdictNone");
  if (score >= 4.5) return t(lang, "verdictExcellent");
  if (score >= 3) return t(lang, "verdictTrusted");
  if (score >= 2) return t(lang, "verdictCaution");
  return t(lang, "verdictPoor");
}

export function scoreText(score) {
  return typeof score === "number" ? clamp(score, 0, 5).toFixed(1) : "—";
}

/** stroke-dasharray for a ring of radius 54 filled proportionally to score/5 */
export function ringDash(score) {
  const circ = 2 * Math.PI * 54;
  const value = typeof score === "number" ? circ * (clamp(score, 0, 5) / 5) : 0;
  return `${value} ${circ}`;
}
